// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rdl-control {
  height: 250px !important;
}

.select-width {
  width: 40%;
  min-width: 250px;
}

.styled-dropdown {
  width: 6px;
  height: 6px;
  background-color: black;
  border-radius: 100%;
}

.header-btn {
  height: 40px;
}

.simplebar-hght {
  height: 120px;
}

.simplebar-content {
  min-height: 200px !important;
  height: auto !important;
}`, "",{"version":3,"sources":["webpack://./../settings/src/components/Benefits/BenefitsTableWrapper.scss"],"names":[],"mappings":"AAAA;EACE,wBAAA;AACF;;AAEA;EACE,UAAA;EACA,gBAAA;AACF;;AAEA;EACE,UAAA;EACA,WAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAGA;EACE,YAAA;AAAF;;AAGA;EACE,aAAA;AAAF;;AAGA;EACE,4BAAA;EACA,uBAAA;AAAF","sourcesContent":[".rdl-control {\n  height: 250px !important;\n}\n\n.select-width {\n  width: 40%;\n  min-width: 250px;\n}\n\n.styled-dropdown {\n  width: 6px;\n  height: 6px;\n  background-color: black;\n  border-radius: 100%;\n}\n\n\n.header-btn {\n  height: 40px;\n}\n\n.simplebar-hght {\n  height: 120px;\n}\n\n.simplebar-content {\n  min-height: 200px !important;\n  height: auto !important;\n}\n "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
